import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03fc05c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "heading-subtitle mt-3 mb-3" }
const _hoisted_3 = { class: "application-notes" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.validationMsg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("h5", _hoisted_2, " Thank you for submitting your elections to P&A Group! You submitted your elections to P&A Group on " + _toDisplayString(_ctx.getEnrollmentDate()), 1),
    _createElementVNode("p", null, [
      _createElementVNode("b", null, "Your confirmation number is " + _toDisplayString(_ctx.profileData.electionId), 1)
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" To save a copy of the enrollment confirmation, please download your confirmation "),
      _createElementVNode("a", {
        class: "a confirmation-download-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadAsPDF && _ctx.downloadAsPDF(...args)))
      }, "here")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _createTextVNode(" If you have any questions about your rights to coverage, please contact P&A Group’s Participant Support Center at (716) 852-2611 or through online webchat at "),
        _createElementVNode("a", {
          href: _ctx.links.contactUs,
          target: "_blank"
        }, _toDisplayString(_ctx.links.contactUs), 9, _hoisted_4),
        _createTextVNode(", Monday – Friday, 8:30 a.m. – 10:00 p.m. ET ")
      ])
    ])
  ], 64))
}